import externalOrderRequestRequests from '@/http/requests/external-order-request'

const { partnerOrderRequestRequests } = externalOrderRequestRequests
const { dispatcherReviewRequestRequests } = externalOrderRequestRequests

export default {
  fetchPartnerOrderRequests: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.getOrderRequests(query)
      .then(response => {
        commit('SET_PARTNER_ORDER_REQUESTS', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  fetchPartnerOrderRequestById: ({ commit }, id) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.getOrderRequestById(id)
      .then(response => {
        commit('SET_PARTNER_ORDER_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  fetchPartnerOrderRequestStatusTotals: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.getOrderRequestStatusTotals(query)
      .then(response => {
        const totalsPayload = response.data || {}
        commit('SET_PARTNER_ORDER_REQUEST_STATUS_TOTALS', {
          draft: totalsPayload.draft || 0,
          submitted: totalsPayload.submitted || 0,
          changes_requested: totalsPayload.changes_requested || 0,
          accepted: totalsPayload.accepted || 0,
          rejected: totalsPayload.rejected || 0,
          cancelled: totalsPayload.cancelled || 0,
        })
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  fetchAllowedCustomers: ({ commit }) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.getAllowedCustomers()
      .then(response => {
        commit('SET_ALLOWED_CUSTOMERS', response.data.items || [])
        commit('SET_ALLOWED_ORDER_TYPES', response.data.allowedOrderTypes || [])
        commit('SET_PARTNER_ORDER_REQUEST_INSTRUCTION', response.data.orderRequestInstruction || null)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  createPartnerOrderRequest: (_, payload) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.createOrderRequest(payload)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),
  updatePartnerOrderRequest: ({ commit }, payload) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.updateOrderRequest(payload.id, payload.data)
      .then(response => {
        commit('SET_PARTNER_ORDER_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  submitPartnerOrderRequest: ({ commit }, id) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.submitOrderRequest(id)
      .then(response => {
        commit('SET_PARTNER_ORDER_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  cancelPartnerOrderRequest: ({ commit }, id) => new Promise((resolve, reject) => {
    partnerOrderRequestRequests.cancelOrderRequest(id)
      .then(response => {
        commit('SET_PARTNER_ORDER_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  fetchDispatcherReviewRequests: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    dispatcherReviewRequestRequests.getReviewRequests(query)
      .then(response => {
        commit('SET_DISPATCHER_REVIEW_REQUESTS', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  fetchDispatcherReviewRequestById: ({ commit }, id) => new Promise((resolve, reject) => {
    dispatcherReviewRequestRequests.getReviewRequestById(id)
      .then(response => {
        commit('SET_DISPATCHER_REVIEW_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  fetchDispatcherReviewPendingTotal: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    dispatcherReviewRequestRequests.getReviewStatusTotals(query)
      .then(response => {
        const pending = Number.isInteger(response?.data?.pending)
          ? response.data.pending
          : (response?.data?.submitted || 0)
        commit('SET_DISPATCHER_REVIEW_PENDING_TOTAL', pending)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  fetchDispatcherReviewStatusTotals: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    dispatcherReviewRequestRequests.getReviewStatusTotals(query)
      .then(response => {
        const totalsPayload = response.data || {}
        const normalizedTotals = {
          submitted: totalsPayload.submitted || 0,
          changes_requested: totalsPayload.changes_requested || 0,
          accepted: totalsPayload.accepted || 0,
          rejected: totalsPayload.rejected || 0,
          cancelled: totalsPayload.cancelled || 0,
        }
        const pending = Number.isInteger(totalsPayload.pending)
          ? totalsPayload.pending
          : normalizedTotals.submitted

        commit('SET_DISPATCHER_REVIEW_STATUS_TOTALS', normalizedTotals)
        commit('SET_DISPATCHER_REVIEW_PENDING_TOTAL', pending)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  acceptDispatcherReviewRequest: ({ commit }, payload) => new Promise((resolve, reject) => {
    dispatcherReviewRequestRequests.acceptReviewRequest(payload.id, payload.data)
      .then(response => {
        commit('SET_DISPATCHER_REVIEW_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  rejectDispatcherReviewRequest: ({ commit }, payload) => new Promise((resolve, reject) => {
    dispatcherReviewRequestRequests.rejectReviewRequest(payload.id, payload.data)
      .then(response => {
        commit('SET_DISPATCHER_REVIEW_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
  requestChangesDispatcherReviewRequest: ({ commit }, payload) => new Promise((resolve, reject) => {
    dispatcherReviewRequestRequests.requestChangesReviewRequest(payload.id, payload.data)
      .then(response => {
        commit('SET_DISPATCHER_REVIEW_REQUEST', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),
}
